import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const CategoryModeration = React.lazy(() => import("@mediaspace/features/category-moderation/CategoryModeration"));

export const ChannelNotificationChecker = React.lazy(
    () => import("@mediaspace/features/category-moderation/category-notification-checker/channel-notification-checker")
);

export const GalleryNotificationChecker = React.lazy(
    () => import("@mediaspace/features/category-moderation/category-notification-checker/gallery-notification-checker")
);

export const ApproveAction = React.lazy(
    () => import("@mediaspace/features/category-moderation/card-actions/approve/approve-container")
);

export const RejectAction = React.lazy(
    () => import("@mediaspace/features/category-moderation/card-actions/reject/reject-container")
);

export const render = getDsLayoutComponentRenderer(CategoryModeration);
